module.exports = __webpack_public_path__ + "static/media/timer-center.78dbef0f.svg";